import { isDev } from "@/utils/enviroment-detector"
import { TipoFile } from "../data/tipoFile"
import type { Produto } from "../types/produto.props"
import { getResourceFromS3 } from "@/utils/getResourceFromS3"

interface MidiaProdutoVitrineProps {
    hostImagem: string
    produto: Produto
    width: number
    height: number
    hoverImagensVitrine?: boolean
    hoverImagensVitrineMobile?: boolean
}

export function MidiaProdutoVitrine({
    hostImagem,
    produto,
    width,
    height,
    hoverImagensVitrine,
    hoverImagensVitrineMobile,
}: Readonly<MidiaProdutoVitrineProps>) {
    const aspectRatio = width > 0 && height > 0 ? `${width}/${height}` : undefined

    const nomeArquivo = produto.midia_arquivo_nome
    const midiaPath = produto.midia_path
    const midiaUrl = produto.midia_url
    const midiaSecundariaUrl = produto.midia_secundaria_url

    // Principal
    let urlImgPrincipalProduto = midiaUrl ?? getResourceFromS3(midiaPath, nomeArquivo, hostImagem)

    // Caso seja vídeo principal
    const isVideoPrincipal = (produto.midia_tipo_file == TipoFile.VIDEO && midiaPath?.endsWith(".mp4")) || ((produto.midia_tipo_file == TipoFile.VIDEO || produto.midia_tipo_file == TipoFile.DOCUMENTO) && nomeArquivo?.endsWith(".mp4"))

    if (isVideoPrincipal) {
        const urlVideo = midiaPath?.endsWith(".mp4") ? midiaPath : (midiaUrl ?? getResourceFromS3(midiaPath, nomeArquivo, hostImagem))

        return (
            <video
                style={{ aspectRatio }}
                width={width || undefined}
                height={height || undefined}
                preload="none"
                className="lazyload"
                muted
                loop
                data-autoplay=""
                playsInline
            >
                <source src={urlVideo} type="video/mp4" />
            </video>
        )
    }

    // Hover (imagem/vídeo secundário)
    let urlProdutoImgSecundaria = ""
    let urlProdutoVideoSecundario = ""
    const tipoImgSecundaria =
        produto.midias && produto.midias.length > 1 ? produto.midias[1].tipo_file : 0

    if (
        produto.midia_secundaria_path &&
        tipoImgSecundaria != TipoFile.VIDEO &&
        !(tipoImgSecundaria == TipoFile.DOCUMENTO &&
            produto.midia_secundaria_arquivo_nome?.endsWith(".mp4"))
    ) {
        urlProdutoImgSecundaria = midiaSecundariaUrl ?? getResourceFromS3(produto.midia_secundaria_path, produto.midia_secundaria_arquivo_nome, hostImagem)
    } else if (
        [TipoFile.VIDEO, TipoFile.DOCUMENTO].includes(tipoImgSecundaria) && produto.midia_secundaria_arquivo_nome?.endsWith(".mp4")
    ) {
        urlProdutoVideoSecundario = midiaSecundariaUrl ?? getResourceFromS3(produto.midia_secundaria_path, produto.midia_secundaria_arquivo_nome, hostImagem)
    }

    // Se principal for tipo 2 (com link) e não for mp4 → usa secundária
    if (
        produto.midia_tipo_file == TipoFile.VIDEO && !produto.midia_path?.endsWith(".mp4")
    ) {
        urlImgPrincipalProduto = urlProdutoImgSecundaria
    }

    // Caso hover esteja habilitado
    if (hoverImagensVitrine || hoverImagensVitrineMobile) {
        return (
            <img
                alt={produto.nome}
                title={produto.nome}
                className="img-principal lazyload"
                data-sizes="auto"
                src={isDev() ? urlImgPrincipalProduto : 'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=='}
                data-src={urlImgPrincipalProduto}
                data-imagem-principal={urlImgPrincipalProduto}
                data-imagem-secundaria={urlProdutoImgSecundaria}
                data-video-secundario={urlProdutoVideoSecundario}
                width={width || undefined}
                height={height || undefined}
            />
        )
    }

    // Caso comum (sem hover)
    const urlProduto = midiaUrl ?? getResourceFromS3(midiaPath, nomeArquivo, hostImagem)

    return (
        <img
            alt={produto.nome}
            title={produto.nome}
            className="lazyload"
            data-sizes="auto"
            src={isDev() ? urlProduto : 'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=='}
            data-src={urlProduto}
            width={width || undefined}
            height={height || undefined}
        />
    )
}
